import { render } from "./TripDetail.vue?vue&type=template&id=c8969888&scoped=true"
import script from "./TripDetail.vue?vue&type=script&lang=js"
export * from "./TripDetail.vue?vue&type=script&lang=js"

import "./TripDetail.vue?vue&type=style&index=0&id=c8969888&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8969888"]])

export default __exports__